import { Button } from "@volca/ui/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@volca/ui/components/ui/dialog";

interface IcmPagePlanMismatchDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  lastRunPlanId: string | null;
  lastRunPlanName: string | null;
  activePlanId: string | null;
  activePlanName: string | null;
  onUsePreviousPlan: (planId?: string) => void;
  onUseCurrentPlan: (planId?: string) => void;
}

export const IcmPagePlanMismatchDialog = ({
  open,
  onOpenChange,
  lastRunPlanId,
  lastRunPlanName,
  activePlanId,
  activePlanName,
  onUsePreviousPlan,
  onUseCurrentPlan,
}: IcmPagePlanMismatchDialogProps) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Plan has changed since last run</DialogTitle>
        <DialogDescription>
          The last completed run used{" "}
          <strong>{lastRunPlanName ?? "an unknown plan"}</strong>, but the
          current active plan is <strong>{activePlanName ?? "unknown"}</strong>.
          Which plan should this run use?
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button
          variant="secondary"
          onClick={() => {
            onOpenChange(false);
            onUsePreviousPlan(lastRunPlanId ?? undefined);
          }}
        >
          Use previous plan
        </Button>
        <Button
          onClick={() => {
            onOpenChange(false);
            onUseCurrentPlan(activePlanId ?? undefined);
          }}
        >
          Use current plan
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
